<template>
  <v-select
    v-model="selected"
    :items="options"
    item-text="Name"
    item-value="value"
    :clearable="!disabled"
    :outlined="!disabled"
    :filled="disabled"
    dense
    hide-details="true"
    label="Viewing Stream"
    id="viewing_stream_select"
    @input="val => $emit('input', val)"
    :readonly="disabled"
    ref="select"
  >
  </v-select>
</template>

<script>
  import { VIEWING_STREAMS } from '@/appLogic/targets/Constants'

  const LIVE = { Name: 'Live', value: VIEWING_STREAMS.LIVE }
  const LSD = { Name: 'Live Same Day', value: VIEWING_STREAMS.LSD }
  const C7 = { Name: 'C7', value: VIEWING_STREAMS.C7 }
  const C3 = { Name: 'C3', value: VIEWING_STREAMS.C3 }
  const LIVE3 = { Name: 'Live + 3', value: VIEWING_STREAMS.LIVE3 }
  // const LIVE7 = { Name: 'Live + 7', value: VIEWING_STREAMS.LIVE7 }

  const VIEWING_OPTIONS = {
    DEFAULT: 1,
    XANDR: 2,
    PID: 3,
    NPOWER: 4,
    LAS: 5,
    DIRECTV: 6,
    ALL: 7,
    NEW_AUDIENCE: 8,
  }

  export default {
    props: {
      initialValue: null,
      size: {
        type: Number,
        default: 1
      },
      viewingOption: {
        type: Number,
        default: 1
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      selected: {
        get () {
          return this.initialValue || ''
        },
        set (newVal) {
          // No action needed
        }
      },
      options () {
        if (this.viewingOption === VIEWING_OPTIONS.DEFAULT || this.viewingOption === VIEWING_OPTIONS.NPOWER) {
          return [LIVE, LSD, C3, C7]
        } else if (this.viewingOption === VIEWING_OPTIONS.XANDR) {
          return [LSD, LIVE3]
        } else if (this.viewingOption === VIEWING_OPTIONS.PID) {
          return [LSD, LIVE, C3]  // C7 theoretically should be supported too but users only asked for C3
        } else if (this.viewingOption === VIEWING_OPTIONS.LAS) {
          return [LSD, C3, C7]
        } else if (this.viewingOption === VIEWING_OPTIONS.DIRECTV) {
          return [LSD]
        } else if (this.viewingOption === VIEWING_OPTIONS.ALL) {
          return [LIVE, LSD, LIVE3, C3, C7]
        } else if (this.viewingOption === VIEWING_OPTIONS.NEW_AUDIENCE) {
          return [LSD, C3]
        }
      }
    }
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// StreamingSelect.vue?2e581589